import {
  ORG_MEMBERS_QUERY_KEY,
  ORG_PROJECTS_QUERY_KEY,
  ORGANIZATIONS_QUERY_KEY,
  PROJECTS_QUERY_KEY,
} from "@frontend-shared/constants";
import type { QueryClient } from "@tanstack/react-query";

// NOTE: Every cache an organization ownership change invalidates (NSAI-3616).
// `isOwner` lives on the organizations query, but a transfer also re-grants
// project-admin on every project in the org, which moves the `permissions`
// flags the owner-gated tabs fall back to — so the project and member lists go
// stale at the same moment. Keys are invalidated by prefix, so the
// uuid-suffixed variants (`[ORG_MEMBERS_QUERY_KEY, uuid]`) are covered too.
// Shared by the WS push handler and the socket-reconnect catch-up so the two
// can never drift apart.
export const invalidateOrganizationAccessQueries = (
  queryClient: QueryClient,
): void => {
  queryClient.invalidateQueries({ queryKey: [ORGANIZATIONS_QUERY_KEY] });
  queryClient.invalidateQueries({ queryKey: [ORG_MEMBERS_QUERY_KEY] });
  queryClient.invalidateQueries({ queryKey: [ORG_PROJECTS_QUERY_KEY] });
  queryClient.invalidateQueries({ queryKey: [PROJECTS_QUERY_KEY] });
};
